<se-timeline-details [clinicalHistory]="groupedData" [formType]="formType"></se-timeline-details>
